import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function BellIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M18 8.132a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9Zm-4.27 13a2 2 0 0 1-3.46 0"
        stroke="currentColor"
      />
    </BaseIcon>
  );
}
